// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { Actor_abstract } from './../abstract/SagaSchema/Actor_abstract';
export class Actor extends Actor_abstract {}
